import { RequestState, RequestType } from '@square/dashboard-protos/models/squareup/secure_profile/common';
export function hasIdentityVerificationRequest(riskProfileUnit) {
  return hasActiveFreeze(riskProfileUnit) && riskProfileUnit.identityVerifications.some(idv => !idv.completedStatus && !idv.erroredStatus);
}
export function getIdentityVerificationRequest(riskProfileUnit) {
  return riskProfileUnit.identityVerifications.find(idv => !idv.completedStatus && !idv.erroredStatus);
}
function hasCompletedIDV(riskProfileUnit) {
  return riskProfileUnit.identityVerifications.some(idv => idv.completedStatus || idv.erroredStatus);
}
function hasPendingSSPRequest(riskProfileUnit) {
  return riskProfileUnit.ssps.some(ssp => ssp.type === RequestType.RISK && (ssp.state === RequestState.PENDING_COMPLETION || ssp.state === RequestState.PENDING_FURTHER_COMPLETION));
}
export function hasNeededSSPRequest(riskProfileUnit) {
  return hasActiveFreeze(riskProfileUnit) && !hasCompletedIDV(riskProfileUnit) && hasPendingSSPRequest(riskProfileUnit);
}
export function hasRecasedSSPRequest(riskProfileUnit) {
  return hasActiveFreeze(riskProfileUnit) && hasCompletedIDV(riskProfileUnit) && hasPendingSSPRequest(riskProfileUnit);
}
function hasActiveFreeze(riskProfileUnit) {
  return riskProfileUnit.freezes.some(freeze => freeze.active);
}